export enum EPalletType {
  ALL = "",
  WOOD = "PW",
  FLAT_PLASTIC = "PP",
  HOLE_PLASTIC = "PF",
  ALUMINUM = "PA",
  TEMPORARY = "PO",
  CONTAINER_PLASTIC = "PC",
}
